import { render, staticRenderFns } from "./tizhibianshi-detail.vue?vue&type=template&id=370d9c2c&scoped=true&"
import script from "./tizhibianshi-detail.vue?vue&type=script&lang=ts&"
export * from "./tizhibianshi-detail.vue?vue&type=script&lang=ts&"
import style0 from "./tizhibianshi-detail.vue?vue&type=style&index=0&id=370d9c2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370d9c2c",
  null
  
)

export default component.exports